import React, { useEffect, useState } from "react";
import Select from "react-select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { indian_states } from "../../../components/Data/IndianStates";
import { countries } from "../../../components/Data/Countries";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaIdCard,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaUniversity,
  FaTint,
  FaBirthdayCake,
  FaChurch,
  FaUpload,
  FaArrowLeft,
  FaSave,
} from "react-icons/fa";

import GeographicalComponent from "../../../components/GeographicalComponent/GeographicalComponent";

const FamilyUpdateChild = ({ familyDetails }) => {
  let navigate = useNavigate();
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [churchList, setChurchList] = useState();
  const [{ errorLogApi, sanitizeInput, bloodgroupOptions, placeHolderText }] =
    useAtom(gbState);

  const [formData, setFormData] = useState({
    family_name: "",
    family_code: "",
    primary_member_id: {
      first_name: "",
      last_name: "",
      mobile: "",
      email: "",
    },
    gender: "",
    social_security_number: "",
    head_of_family: false,
    communicant_member: false,
    birth_day: "",
    birth_month: "",
    birth_year: "",
    date_of_joining: null,
    address: "",
    zipcode: "",
    blood_group: "",
    qualification: "",
    birth_place: "",
    is_alive: true,
    church_id: "",
    parent_church_id: "",
  });

  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/family/records/${familyDetails?._id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const family = response.data;
        setFormData({
          ...family,
          primary_member_id: family.primary_member_id || {
            first_name: "",
            last_name: "",
            mobile: "",
            email: "",
          },
          first_name: family?.primary_member_id?.first_name || "",
          last_name: family?.primary_member_id?.last_name || "",
          mobile: family?.primary_member_id?.mobile || "",
          email: family?.primary_member_id?.email || "",
          date_of_joining: family.date_of_joining
            ? dayjs(family.date_of_joining)
            : null,
        });
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        // errorLogApi(error, "ChurchList", "/churches");
      });
  }, [familyDetails]);

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/churches/`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const churches = response.data.churches;
        setChurchList(
          churches.map((church) => ({
            value: church._id,
            label: church.church_name + " (" + church.city + ")",
          }))
        );
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "ChurchList", "/churches");
      });
  }, []);

  const handleCertificateChange = (event) => {
    setSelectedCertificate(event.target.files[0]);
  };

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const formatSSN = (value) => {
    // Remove all non-digits
    const cleaned = value.replace(/\D/g, "");
    // Format with dashes
    if (cleaned.length >= 9) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(
        5,
        9
      )}`;
    } else if (cleaned.length > 5) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(
        5
      )}`;
    } else if (cleaned.length > 3) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    }
    return cleaned;
  };

  const handleChange = ({ currentTarget: input }) => {
    if (input.name === "family_name") {
      setFormData({
        ...formData,
        [input.name]: input.value,
        last_name: input.value, // Automatically set last name when family name changes
      });
    } else if (input.name === "social_security_number") {
      const formattedSSN = formatSSN(input.value);
      input.value = formattedSSN;
      setFormData({
        ...formData,
        [input.name]: formattedSSN,
      });
    } else {
      setFormData({
        ...formData,
        [input.name]: input.value,
      });
    }
  };

  const indianStates = Object.keys(indian_states);
  const indianStatesOption = indianStates.map((data) => ({
    value: data,
    label: data,
  }));

  const inputElementWidthStyle = `w-full p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md`;

  const countriesOption = countries.map((country) => ({
    value: country.code,
    label: country.name,
  }));

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "nonbinary", label: "Non-binary" },
    { value: "other", label: "Other" },
  ];

  const dayOptions = Array.from({ length: 31 }, (_, i) => {
    const day = (i + 1).toString().padStart(2, "0");
    return { value: day, label: day };
  });

  const monthOptions = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const binaryOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const handleFamilyUpdate = () => {
    // Validate required fields with friendly messages
    const requiredFields = {
      family_name: "a family name",
      first_name: "the first name",
      last_name: "the last name",
      mobile: "a valid mobile number",
      email: "an email address",
      head_of_family: "the head of family status",
      communicant_member: "the communicant member status",
      birth_day: "the birth day",
      birth_month: "the birth month",
      gender: "the gender",
      country: "the country",
      state: "the state",
      city: "the city",
    };

    // Check required fields with friendly messages
    for (const [field, label] of Object.entries(requiredFields)) {
      if (!formData[field]) {
        toast.error(`Please enter ${label} to continue`);
        return;
      }
    }

    // Validate email format with friendly message
    if (
      formData.email &&
      !formData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
    ) {
      toast.error(
        "The email address format is invalid. Please enter a valid email address"
      );
      return;
    }

    // Validate mobile number format with friendly message
    if (!formData.mobile.match(/^\d{10}$/)) {
      toast.error(
        "Please enter a valid 10-digit mobile number without spaces or special characters"
      );
      return;
    }

    // Validate password match if password is being updated
    if (formData.password || formData.confirm_password) {
      if (formData.password !== formData.confirm_password) {
        toast.error("Passwords do not match");
        return;
      }
      if (formData.password.length < 6) {
        toast.error("Password must be at least 6 characters long");
        return;
      }
    }

    let userToken = localStorage.getItem("token");

    // Create FormData object
    const formDataObj = new FormData();

    // Append all form fields
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && formData[key] !== undefined) {
        // Handle special cases for nested objects
        if (key === "primary_member_id" && typeof formData[key] === "object") {
          formDataObj.append(key, formData[key]._id);
        } else if (key === "church_id" && typeof formData[key] === "object") {
          formDataObj.append(key, formData[key]._id);
        } else if (key === "country" && typeof formData[key] === "object") {
          formDataObj.append(key, JSON.stringify(formData[key]));
        } else if (key === "state" && typeof formData[key] === "object") {
          formDataObj.append(key, JSON.stringify(formData[key]));
        } else if (key === "city" && typeof formData[key] === "object") {
          formDataObj.append(key, JSON.stringify(formData[key]));
        } else if (typeof formData[key] === "object") {
          // Skip object fields that we don't want to send
          console.log("Skipping object field:", key);
        } else {
          formDataObj.append(key, formData[key]);
        }
      }
    });

    // Handle image upload
    if (selectedImage) {
      formDataObj.append("image", selectedImage);
    }

    // Handle certificate upload
    if (selectedCertificate) {
      formDataObj.append("certificate_upload", selectedCertificate);
    }

    // Log the form data entries
    console.log("Form Data Entries:");
    for (let pair of formDataObj.entries()) {
      console.log(pair[0], pair[1]);
    }

    const config = {
      method: "patch",
      url: `${process.env.REACT_APP_API_URL}/family/update/${familyDetails._id}`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: formDataObj,
    };

    axios(config)
      .then(function (response) {
        toast.success("Family details updated successfully");
        navigate("/families");
      })
      .catch(function (error) {
        // Handle specific error cases
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "An error occurred while updating family details";

        if (error?.response?.status === 401) {
          toast.error("Session expired. Please login again");
          navigate("/login");
        } else if (error?.response?.status === 403) {
          toast.error("You don't have permission to perform this action");
        } else if (error?.response?.status === 400) {
          toast.error(errorMessage);
        } else {
          toast.error(
            "Unable to update family details. Please try again later"
          );
        }

        errorLogApi(error, "FamilyUpdateChild", "/family/update", {
          familyId: familyDetails._id,
          formData: formData,
        });
      });
  };

  const handleFamilyUpdatev1 = () => {
    // Validate required fields with friendly messages
    const requiredFields = {
      family_name: "a family name",
      first_name: "the first name",
      last_name: "the last name",
      mobile: "a valid mobile number",
      email: "an email address",
      head_of_family: "the head of family status",
      communicant_member: "the communicant member status",
      birth_day: "the birth day",
      birth_month: "the birth month",
      gender: "the gender",
      country: "the country",
    };

    // Check required fields with friendly messages
    for (const [field, label] of Object.entries(requiredFields)) {
      if (!formData[field]) {
        toast.error(`Please enter ${label} to continue`);
        return;
      }
    }

    // Validate email format with friendly message
    if (
      formData.email &&
      !formData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
    ) {
      toast.error(
        "The email address format is invalid. Please enter a valid email address"
      );
      return;
    }

    // Validate mobile number format with friendly message
    if (!formData.mobile.match(/^\d{10}$/)) {
      toast.error(
        "Please enter a valid 10-digit mobile number without spaces or special characters"
      );
      return;
    }

    // Validate password match if password is being updated
    if (formData.password || formData.confirm_password) {
      if (formData.password !== formData.confirm_password) {
        toast.error("Passwords do not match");
        return;
      }
      if (formData.password.length < 6) {
        toast.error("Password must be at least 6 characters long");
        return;
      }
    }

    let userToken = localStorage.getItem("token");

    // Create FormData object
    const formDataObj = new FormData();

    // Append all form fields
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && formData[key] !== undefined) {
        // Handle special cases for nested objects
        if (key === "primary_member_id" && typeof formData[key] === "object") {
          formDataObj.append(key, formData[key]._id);
        } else if (key === "church_id" && typeof formData[key] === "object") {
          formDataObj.append(key, formData[key]._id);
        } else if (typeof formData[key] === "object") {
          // Skip object fields that we don't want to send
          console.log("Skipping object field:", key);
        } else {
          formDataObj.append(key, formData[key]);
        }
      }
    });

    // Handle image upload
    if (selectedImage) {
      formDataObj.append("image", selectedImage);
    }

    // Handle certificate upload
    if (selectedCertificate) {
      formDataObj.append("certificate_upload", selectedCertificate);
    }

    // Log the form data entries
    console.log("Form Data Entries:");
    for (let pair of formDataObj.entries()) {
      console.log(pair[0], pair[1]);
    }

    const config = {
      method: "patch",
      url: `${process.env.REACT_APP_API_URL}/family/update/${familyDetails._id}`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: formDataObj,
    };

    axios(config)
      .then(function (response) {
        toast.success("Family details updated successfully");
        navigate("/families");
      })
      .catch(function (error) {
        // Handle specific error cases
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "An error occurred while updating family details";

        if (error?.response?.status === 401) {
          toast.error("Session expired. Please login again");
          navigate("/login");
        } else if (error?.response?.status === 403) {
          toast.error("You don't have permission to perform this action");
        } else if (error?.response?.status === 400) {
          toast.error(errorMessage);
        } else {
          toast.error(
            "Unable to update family details. Please try again later"
          );
        }

        errorLogApi(error, "FamilyUpdateChild", "/family/update", {
          familyId: familyDetails._id,
          formData: formData,
        });
      });
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#F9FAFB",
      borderColor: "#D1D5DB",
      "&:hover": {
        borderColor: "#3B82F6",
      },
    }),
  };

  return (
    <div className="w-full min-h-screen p-0">
      <div className="p-8 mx-auto">
        <div className="flex flex-col items-center justify-between mb-8 sm:flex-row">
          <h1 className="mb-4 text-3xl font-bold text-gray-800 sm:mb-0">
            Update Family
          </h1>
          <button
            className="flex items-center px-4 py-2 text-sm text-white transition duration-300 ease-in-out bg-gray-600 rounded-md hover:bg-gray-700"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="mr-2" /> Back
          </button>
        </div>

        <form className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="col-span-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Family Name
            </label>
            <div className="relative">
              <FaUser className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="family_name"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter family name"
                value={formData?.family_name || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              First Name
            </label>
            <div className="relative">
              <FaUser className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="first_name"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter first name"
                value={formData?.first_name}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Last Name
            </label>
            <div className="relative">
              <FaUser className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="last_name"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter last name"
                value={formData?.last_name}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Date of Birth
            </label>
            <div className="flex space-x-2">
              <Select
                name="birth_month"
                onChange={dropDownChange}
                options={monthOptions}
                className="w-1/3"
                placeholder="Month"
                styles={selectStyles}
                value={
                  formData.birth_month
                    ? {
                        value: formData.birth_month,
                        label: formData.birth_month,
                      }
                    : null
                }
              />
              <Select
                name="birth_day"
                onChange={dropDownChange}
                options={dayOptions}
                className="w-1/3"
                placeholder="Day"
                styles={selectStyles}
                value={
                  formData.birth_day
                    ? { value: formData.birth_day, label: formData.birth_day }
                    : null
                }
              />

              <DatePicker
                className="w-1/3 h-[38px] bg-gray-50 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                name="birth_year"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    birth_year: dateString,
                  });
                }}
                picker="year"
                placeholder="Year"
                value={formData.birth_year ? dayjs(formData.birth_year) : null}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Gender
            </label>
            <Select
              name="gender"
              onChange={dropDownChange}
              options={genderOptions}
              className="w-full"
              placeholder="Select Gender"
              styles={selectStyles}
              value={
                formData.gender
                  ? genderOptions.find(
                      (g) => g.value === formData.gender.toLowerCase()
                    )
                  : null
              }
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Social Security Number
            </label>
            <div className="relative">
              <FaIdCard className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="social_security_number"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter SSN number"
                value={formData.social_security_number || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Mobile
            </label>
            <div className="relative">
              <FaPhone className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="mobile"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter mobile number"
                value={formData.mobile}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Email
            </label>
            <div className="relative">
              <FaEnvelope className="absolute text-gray-400 top-3 left-3" />
              <input
                type="email"
                name="email"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter email address"
                autoComplete="off"
                value={formData.email}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute text-gray-400 top-3 left-3" />
              <input
                type="password"
                name="password"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter password"
                autoComplete="new-password"
                value={formData.password || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Confirm Password
            </label>
            <div className="relative">
              <FaLock className="absolute text-gray-400 top-3 left-3" />
              <input
                type="password"
                name="confirm_password"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Confirm password"
                value={formData.confirm_password || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Head of Family
            </label>
            <Select
              name="head_of_family"
              onChange={dropDownChange}
              options={binaryOptions}
              className="w-full"
              placeholder="Select Head of Family"
              styles={selectStyles}
              value={
                formData.head_of_family
                  ? {
                      value: formData.head_of_family,
                      label: formData.head_of_family === 1 ? "Yes" : "No",
                    }
                  : null
              }
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Communicant Member
            </label>
            <Select
              name="communicant_member"
              onChange={dropDownChange}
              options={binaryOptions}
              className="w-full"
              placeholder="Select Communicant Member"
              styles={selectStyles}
              value={
                formData.communicant_member
                  ? {
                      value: formData.communicant_member,
                      label: formData.communicant_member === 1 ? "Yes" : "No",
                    }
                  : null
              }
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Parent Church
            </label>
            <Select
              name="parent_church_id"
              onChange={dropDownChange}
              options={churchList}
              className="w-full"
              placeholder="Select Parent Church"
              styles={selectStyles}
              value={
                formData.parent_church_id
                  ? churchList &&
                    churchList.find(
                      (item) => item.value === formData.parent_church_id
                    )
                  : null
              }
            />
          </div>

          <div className="col-span-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Profile Image
            </label>
            <div className="relative">
              <FaUpload className="absolute text-gray-400 top-3 left-3" />
              <input
                type="file"
                name="image"
                onChange={handleImageChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                accept="image/*"
              />
            </div>
          </div>

          <div className="col-span-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Certificate Upload
            </label>
            <div className="relative">
              <FaUpload className="absolute text-gray-400 top-3 left-3" />
              <input
                type="file"
                name="certificate_upload"
                onChange={handleCertificateChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                accept=".pdf,.doc,.docx"
              />
            </div>
          </div>

          <GeographicalComponent
            setFormData={setFormData}
            formData={formData}
            handleChange={handleChange}
            dropDownChange={dropDownChange}
            style={style}
            placeHolderText={placeHolderText}
          />

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Address
            </label>
            <div className="relative">
              <FaMapMarkerAlt className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="address"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter address"
                value={formData.address || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Area
            </label>
            <div className="relative">
              <FaMapMarkerAlt className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="area"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter area"
                value={formData.area || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Zip code
            </label>
            <div className="relative">
              <FaMapMarkerAlt className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="zipcode"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter zipcode"
                value={formData.zipcode || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Qualification / Job Profile
            </label>
            <div className="relative">
              <FaUniversity className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="qualification"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter qualification"
                value={formData.qualification || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Blood Group
            </label>
            <Select
              name="blood_group"
              onChange={dropDownChange}
              options={bloodgroupOptions}
              className="w-full"
              placeholder="Select Blood Group"
              styles={selectStyles}
              value={
                formData.blood_group
                  ? { value: formData.blood_group, label: formData.blood_group }
                  : null
              }
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Birth Place
            </label>
            <div className="relative">
              <FaBirthdayCake className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="birth_place"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter birth place"
                value={formData.birth_place || ""}
              />
            </div>
          </div>

          {/* Church Account ID */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Church Account ID
            </label>
            <div className="relative">
              <FaChurch className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="church_account_id"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter church account ID"
                value={formData.church_account_id || ""}
              />
            </div>
          </div>

          {/* deceased_status  */}
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Deceased Status
            </label>
            <Select
              name="deceased_status"
              onChange={dropDownChange}
              options={[
                { value: true, label: "True" },
                { value: false, label: "False" },
              ]}
              className="w-full"
              placeholder="Select Deceased Status"
              styles={selectStyles}
              value={
                formData.deceased_status !== undefined
                  ? {
                      value: formData.deceased_status,
                      label: formData.deceased_status ? "True" : "False",
                    }
                  : null
              }
            />
          </div>

          {/* date_of_death  */}
          {formData.deceased_status && (
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Date of Death
              </label>
              <DatePicker
                className="w-full h-[38px] bg-gray-50 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                name="date_of_death"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    date_of_death: dateString,
                  });
                }}
                required={true}
                placeholder="Enter date of death"
                value={
                  formData.date_of_death ? dayjs(formData.date_of_death) : null
                }
              />
            </div>
          )}

          {/* death_reported_by */}
          {formData.deceased_status && (
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Death Reported By
              </label>
              <input
                type="text"
                name="death_reported_by"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter death reported by"
                value={formData.death_reported_by || ""}
              />
            </div>
          )}

          {/* Save button at the bottom */}
          <div className="flex justify-center col-span-2 mt-6">
            <button
              className="flex items-center px-6 py-3 text-white transition duration-300 ease-in-out bg-blue-600 rounded-md hover:bg-blue-700"
              onClick={handleFamilyUpdate}
              type="button"
            >
              <FaSave className="mr-2" /> Update Family Details
            </button>
          </div>
          {/* {JSON.stringify(formData)} */}
        </form>
        <div className="flex justify-center mt-2">
          <button
            className="flex items-center px-6 py-3 text-sm text-white transition duration-300 ease-in-out bg-gray-600 rounded-md hover:bg-gray-700"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="mr-2" /> Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default FamilyUpdateChild;
